import { CSVLink } from "react-csv";
import { Box, Button } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { apiGetRequest } from "utils/api";
import { useState } from "react";

export function PhoenixDashboardFeesDownload() {
  const [items, setItems] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  async function handleDownload() {
    setIsLoading(true);
    try {
      const items = await apiGetRequest("/phoenix/dashboard-fees");
      setItems(items);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <Box>
      <CSVLink
        data={items}
        filename={`dashboard_fees_export_${new Date().getTime()}.csv`}
        asyncOnClick
        onClick={async () => await handleDownload()}
        style={{ marginRight: "16px" }}
      >
        <Button
          variant="ghost"
          leftIcon={<FontAwesomeIcon icon={["fas", "download"]} />}
          isLoading={isLoading}
          isDisabled={isLoading}
        >
          Fees
        </Button>
      </CSVLink>
    </Box>
  );
}
